import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "semantic-ui-react";

import { Can, Dropdown, NavPortal, SearchFilter } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { CreateDealerModal } from "modules/DealersDashboard/components";
import "modules/DealersDashboard/components/DealersDashboardFilters/DealersDashboardFilters.scss";
import { setDealersDashboardFilters, useGetDealersDashboardFilters } from "modules/DealersDashboard/components/DealersDashboardFilters/hooks";
import { DEALER_STATUSES } from "modules/DealersDashboard/queryKeys";

export const DealersDashboardFilters = () => {
  const { t } = useTranslation();

  const [isCreateDealerModalOpen, setIsCreateDealerModalOpen] = useState(false);
  const { data: filters } = useGetDealersDashboardFilters();

  const statusOptions = [
    { key: DEALER_STATUSES.All, value: DEALER_STATUSES.All, text: t("v8_all", "All") },
    { key: DEALER_STATUSES.Active, value: DEALER_STATUSES.Active, text: t("v8_active", "Active") },
    { key: DEALER_STATUSES.Inactive, value: DEALER_STATUSES.Inactive, text: t("v8_inactive", "Inactive") }
  ];

  return (
    <>
      <NavPortal>
        <SearchFilter value={filters.term} handleSearchChange={term => setDealersDashboardFilters({ term })} />
      </NavPortal>
      <div className="filters-toolbar-container DealersDashboardFilters">
        <Can I={ACL_ACTIVITIES.Create} the={ACL_RESOURCES.Dealers}>
          <Button basic icon className="add-btn" onClick={() => setIsCreateDealerModalOpen(true)}>
            <Icon className="plus" />
          </Button>
        </Can>
        <Button basic icon className="expand-btn" onClick={() => setDealersDashboardFilters({ areLocationsExpanded: !filters.areLocationsExpanded })}>
          <Icon className="arrows maximize vertical" />
          <span className="expand-text">{filters.areLocationsExpanded ? t("v8_collapse_all", "Collapse All") : t("v8_expand_all", "Expand All")}</span>
        </Button>
        <Dropdown
          selection
          clearable
          name="dealerStatus"
          value={filters.status ?? undefined}
          selectOnBlur={false}
          options={statusOptions}
          className="status-dropdown"
          placeholder={t("v8_filter_by_status", "Filter by status")}
          onChange={status => setDealersDashboardFilters({ status: status ?? null })}
        />
      </div>
      <CreateDealerModal isOpen={isCreateDealerModalOpen} onClose={() => setIsCreateDealerModalOpen(false)} />
    </>
  );
};
